<template>
<section class="about-us" :id="$t('routes.community')" :ref="$t('routes.community')">
    <div class="sloth-container">
        <h3 class="section-title text-center">
            {{ $t('navigation.community_title') }}
        </h3>
        <div class="about-team">
            <div class="about-team-cover floating">
                <img src="/assets/images/community-team-splash.svg" alt="">
            </div>
                <div class="about-team-content">
                    <h2 class="about-team-title">
                        {{ $t('community.title')}}
                    </h2>
                    <p class="about-team-description">
                        {{ $t('community.message')}}
                    </p>
                    <br>
                    <p class="about-team-description">
                        <!-- <q>{{  $t('community.description')}}</q>
                        <br>
                        <i>Richard Stallman</i>
                        <br>
                        <br> -->
                        <router-link class="button-primary-cta" to="/community">{{$t('community.take_part')}}</router-link>
                    </p>
                </div>
            </div>
        </div>
</section>
</template>

<script>
export default {
    name: "Community",

};
</script>
